<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Cấu hình câu hỏi</v-tab>
      <v-tab v-if="survey.status !== 'draft'" class="tab-default" :key="2"> Chi tiết báo cáo </v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <InfoQuestionView />
        </v-tab-item>
        <v-tab-item :key="2">
          <QuestionReportView />
        </v-tab-item>
        <v-tab-item :key="3"> </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import InfoQuestionView from './InfoQuestionView.vue'
import QuestionReportView from './components/SurveyTab/QuestionReportView.vue'
import { mapState } from 'vuex'

export default {
  components: { InfoQuestionView, QuestionReportView },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    ...mapState({
      survey: state => state.survey.item
    })
  }
}
</script>

<style></style>
